export const POLLING_INTERVAL = {
  5: '5 mins',
  15: '15 mins',
  30: '30 mins',
  60: '60 mins',
  120: '2 hours',
  480: '8 hours',
  720: '12 hours',
  1440: '24 hours'
};
